import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import EditPurchase from './EditPurchase';
function EditPurchaseOrder() {
  return (
		<div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
			<Helmet>
				<title>Purchase Order - Edit</title>
			</Helmet>
			<Header />
			<div
				className="container-fluid maindiv d-flex flex-column"
				style={{ flexGrow: "1" }}
			>
				<EditPurchase />
			</div>
		</div>
	);
}

export default EditPurchaseOrder
